import { render, staticRenderFns } from "./AccList.vue?vue&type=template&id=4622d398&scoped=true"
import script from "./AccList.vue?vue&type=script&lang=js"
export * from "./AccList.vue?vue&type=script&lang=js"
import style0 from "./AccList.vue?vue&type=style&index=0&id=4622d398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622d398",
  null
  
)

export default component.exports